import { request, METHOD } from '@/utils/request'
import { BASE_URL } from '@/config/public'

export async function rqtGetPlace(params) {
  return request(
    `${BASE_URL}/provider/ams/place/${params.placeType}/${params.placeCode}`,
    METHOD.GET,
    params
  )
}

export async function rqtGetPlaceByType(params) {
  return request(
    `${BASE_URL}/provider/ams/place/list/${params.placeType}`,
    METHOD.GET,
    null
  )
}

export async function rqtGetPlaceChildrenByType(params) {
  return request(
    `${BASE_URL}/provider/ams/place/list/${params.placeType}/children/${params.upPlaceCode}`,
    METHOD.GET,
    null
  )
}
